import { css } from "styled-components";
import { REGISTRATION_FONT_BODY } from "./registrationTheme";

/** Shared scroll-body and card chrome for registration setup screens */
export const registrationScrollBodyStyles = css`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  max-height: 100%;
  padding-top: clamp(24px, 2.5vw + 14px, 50px);
  padding-bottom: clamp(24px, 0.75vw + 20px, 32px);
  padding-inline: clamp(12px, 1.5vw + 6px, 24px);
`;

export const registrationCardHeaderStyles = css`
  flex-shrink: 0;
  width: 100%;
  padding: 20px 20px 12px;
  background: #ffffff;
  border-bottom: none;
  box-sizing: border-box;

  @media (min-width: 600px) {
    padding: 24px 32px 12px;
  }

  .registration-card-header-row {
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: none;
  }

  .registration-card-back-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: #2d3f52;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-family: ${REGISTRATION_FONT_BODY};

    &:hover {
      color: #5a6b80;
    }
  }

  .registration-card-header-row .section-eyebrow {
    margin-bottom: 0;
  }
`;

export const registrationContentCardStyles = css`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;
  width: 100%;
  max-width: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 32px rgba(30, 42, 53, 0.1);
  border: 1px solid rgba(30, 42, 53, 0.07);
  overflow: hidden;
  box-sizing: border-box;
`;